import { decrypt } from '@/utils/decryptQrc'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

const useClickId = () => {
  const store = useStore()
  const route = useRoute()
  const { query } = route
  const commonDsl = computed(() => store.state.dslData.commonDsl)
  const clickId = computed(() => {
    // 获取clickId的方法
    const { channel = '' } = commonDsl.value || {}
    if (channel.indexOf('UC') !== -1) {
      // uc渠道
      return query.uctrackid
    } else if (channel.indexOf('BAI_DU') !== -1) {
      // 百度渠道
      return query.bd_vid
    } else if (channel.indexOf('TENG_XUN') !== -1) {
      // 腾讯渠道
      return query.gdt_vid || query.qz_gdt
    } else if (channel.indexOf('BYTE_DANCE') !== -1) {
      // 头条渠道
      return query.clickid
    } else if (channel.indexOf('HUA_WEI') !== -1) {
      // 华为渠道
      return query.oaid
    }
    return ''
  })

  const bid = computed(() => {
    if (query.sbid) return decrypt(query.sbid)
    if (query.bid) return query.bid
    if (commonDsl.value?.bid) return commonDsl.value?.bid
    return ''
  })

  const notifyType = computed(() => {
    switch (query.channel || commonDsl.value?.channel) {
      case 'BAIDU_INFO_H5_S':
        return 'BAI_DU_INFO_H5'
      case 'BYTE_DANCE_H5_S':
        return 'BYTE_DANCE_H5'
      case 'TENG_XUN_GDT_S':
        return 'TENG_XUN_GDT'
      case 'UC_H5_S':
        return 'UC_H5'
      default:
        return query.channel || commonDsl.value?.channel
    }
  })

  return {
    bid,
    clickId,
    notifyType,
  }
}

export default useClickId
